import { render } from "./DocumentsEditionAndRedaction.vue?vue&type=template&id=596de529"
import script from "./DocumentsEditionAndRedaction.vue?vue&type=script&lang=js"
export * from "./DocumentsEditionAndRedaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__